export const VIDEO_WINDOW_OPEN = 'VIDEO_WINDOW_OPEN';
export const VIDEO_OPEN_USER_VIDEO = 'VIDEO_OPEN_USER_VIDEO';
export const VIEW_USER_REQUEST = 'VIEW_USER_REQUEST';
export const VIEW_USER_SUCCESS = 'VIEW_USER_SUCCESS';
export const VIDEO_CANPLAY = 'VIDEO_CANPLAY';
export const VIEW_USER_STOP = 'VIEW_USER_STOP';
export const VIEW_USER_RECONNECT = 'VIEW_USER_RECONNECT';
export const VIDEO_WINDOW_CLOSE = 'VIDEO_WINDOW_CLOSE';
export const VIEW_LEAVE = 'VIEW_LEAVE';
export const VIEW_FULLSCREEN = 'VIEW_FULLSCREEN';
export const VIEW_WINDOW = 'VIEW_WINDOW';
export const VIEW_WINDOW_RESIZE = 'VIEW_WINDOW_RESIZE';
export const STREAM_WATCHING_ME = 'STREAM_WATCHING_ME';
export const STREAM_WATCHER_COUNT = 'STREAM_WATCHER_COUNT';
export const STREAM_LIMIT_REACHED = 'STREAM_LIMIT_REACHED';

export const STREAM_STREAM_UPDATE = 'STREAM_STREAM_UPDATE';

export const STREAM_LIMIT_DESKTOP = 10;
export const STREAM_LIMIT_TABLET = 4;
export const STREAM_LIMIT_MOBILE = 1;

export const STREAM_STATUS_STOPPED = 'STREAM_STATUS_STOPPED';
export const STREAM_STATUS_STARTED = 'STREAM_STATUS_STARTED';
export const STREAM_STATUS_ERROR = 'STREAM_STATUS_ERROR';

export const VIEW_STOP_REASON_LIMIT_REACHED = 'LIMIT_REACHED';
export const VIEW_STOP_REASON_WATCH_CLOSED = 'WATCH_CLOSED';

export const STREAMING_STOPPED = 'stopped';
export const STREAMING_STARTED = 'started';
export const STREAMING_ERROR = 'error';

export const WINDOW_SMALL = 'small';
export const WINDOW_MEDIUM = 'medium';
export const WINDOW_LARGE = 'large';
export const WINDOW_SIZES = [WINDOW_SMALL, WINDOW_MEDIUM, WINDOW_LARGE];

export const VIDEO_WINDOW_STATE_OPENED = 'OPENED';
export const VIDEO_WINDOW_STATE_CONNECTING = 'CONNECTING';
export const VIDEO_WINDOW_STATE_CONNECTED = 'CONNECTED';
export const VIDEO_WINDOW_STATE_ONLINE = 'ONLINE';
export const VIDEO_WINDOW_STATE_PAUSED = 'PAUSED';
export const VIDEO_WINDOW_STATE_OFFLINE = 'OFFLINE';
export const VIDEO_WINDOW_STATE_LIMIT_REACHED = 'VIDEO_WINDOW_STATE_LIMIT_REACHED';

// todo: maybe move to blocking constants
export const VIDEO_WINDOW_STATE_BLOCKED = 'BLOCKED';

export const MY_VIDEO_WINDOW_DEFAULT_STATE = {
    shown: true,
    paused: false,
    sound: false,
    fullscreen: false,
    recording: false,
    max_length: 0,
    error: false,
    message: '',
};


// WEBPACK FOOTER //
// ./src/constants/streaming.js